import { Link } from "react-router-dom";
import { LuConstruction } from "react-icons/lu";
import AdminLayout from "../../app-components/AdminLayout";
import PageHeader from "../../app-components/ui/PageHeader";
import { btnSecondary, card } from "../../app-components/ui/styles";
import { SITELINKS } from "../../app-routes/links";

/** Placeholder for account-menu pages that are planned but not built yet */
const ComingSoon = ({ title, description }: { title: string; description: string }) => (
  <AdminLayout title={`Admin | ${title}`}>
    <PageHeader title={title} />
    <div className={card}>
      <div className="flex flex-col items-center px-6 py-16 text-center">
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-hc_F4EBFA text-honeConnectPurple">
          <LuConstruction className="text-2xl" aria-hidden />
        </div>
        <p className="mb-1 font-semibold text-honeConnectBlack">This page is on the way</p>
        <p className="max-w-md text-sm text-hcMuted">{description}</p>
        <Link to={SITELINKS.DASHBOARD} className={`${btnSecondary} mt-6`}>
          Back to dashboard
        </Link>
      </div>
    </div>
  </AdminLayout>
);

export default ComingSoon;
